import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';

export interface TopBlockPropsType {
    disabled: boolean;
    disableEdit: boolean;
    filesError: boolean;
    handleImport: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate('productsImport.import'),
                        onClick: () => {
                            props.handleImport();
                        },
                        disabled: props.disabled || props.disableEdit || props.filesError,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
